import { Link } from "react-router-dom";
import UsersIcon from "../../../img/svg/usersIcon";
import ContactIcon from "../../../img/svg/contactIcon";
import WhatsappIcon from "../../../img/svg/whatsappIcon";
import MapPinIcon from "../../../img/svg/mapPinIcon";
import WatchIcon from "../../../img/svg/watchIcon";
import CheckIcon from "../../../img/svg/checkIcon";

interface IStep {
    title: string;
    description: string;
    items: string[];
    footnote?: string;
    icon: JSX.Element;
    reverse?: boolean;
}

const steps: IStep[] = [
    {
        title: "Vendedores selecionados",
        description: "Todos os anunciantes da plataforma passam por uma curadoria cuidadosa. Você estará negociando com pessoas previamente avaliadas e confiáveis.",
        items: ["Perfis analisados manualmente", "Histórico conhecido", "Compromisso com autenticidade"],
        icon: <UsersIcon width="90px" fill="#111827" />,
    },
    {
        title: "Complete seu cadastro",
        description: "Um perfil completo facilita a comunicação e aumenta a confiança na negociação.",
        items: ["Nome completo", "Telefone válido", "E-mail atualizado"],
        footnote: "Isso ajuda o vendedor a identificar você com mais segurança.",
        icon: <ContactIcon width="80px" fill="#111827" />,
        reverse: true,
    },
    {
        title: "Negociação direta",
        description: "Você pode falar diretamente com o vendedor para tirar dúvidas e alinhar detalhes.",
        items: ["Converse por telefone ou WhatsApp", "Tire todas as dúvidas antes de fechar", "Peça mais fotos ou vídeos, se desejar"],
        icon: <WhatsappIcon width="80px" fill="#111827" />,
    },
    {
        title: "Combine a melhor forma de entrega",
        description: "A entrega é combinada diretamente entre comprador e vendedor.",
        items: ["Retirada presencial (quando possível)", "Envio com seguro", "Acompanhamento da entrega"],
        icon: <MapPinIcon width="80px" fill="#111827" />,
        reverse: true,
    },
    {
        title: "Verifique os detalhes do relógio",
        description: "Relógios são peças únicas e valiosas. Aproveite o contato direto para entender todos os detalhes.",
        items: ["Estado de conservação", "Caixa e documentos", "Histórico e revisões"],
        icon: <WatchIcon width="80px" fill="#111827" />,
    },
];

export default function GuiaCompraSegura() {
    return (
        <main className="bg-white pb-32 pt-24 overflow-hidden">
            <div className="max-w-4xl mx-auto px-6 text-center mb-20 animate-superfade">
                <p className="text-secondary font-bold tracking-[0.4em] text-xs uppercase mb-6">Negocie com Confiança</p>
                <h1 className="font-outfit text-4xl md:text-6xl font-black text-primary tracking-widest mb-8">
                    GUIA DE COMPRA <br className="hidden md:block" /> SEGURA
                </h1>
                <div className="flex justify-center mb-10">
                    <div className="w-20 h-1 bg-secondary rounded-full" />
                </div>
                <p className="text-xl text-mono leading-relaxed max-w-2xl mx-auto">
                    Aqui você negocia diretamente com vendedores selecionados e confiáveis. Nosso objetivo é oferecer um ambiente seguro, transparente e de alto nível em cada negociação.
                </p>
            </div>

            <div className="max-w-4xl mx-auto px-6 space-y-32">
                {steps.map((step, i) => (
                    <div key={step.title} className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center animate-superfade">
                        <div className={`space-y-6 ${step.reverse ? "order-1 md:order-2" : ""}`}>
                            <div className="w-12 h-1 bg-secondary" />
                            <h2 className="text-2xl font-black text-primary uppercase tracking-widest">{step.title}</h2>
                            <p className="text-mono leading-relaxed">{step.description}</p>
                            <ul className="space-y-3 pt-2">
                                {step.items.map((item) => (
                                    <li key={item} className="flex items-center gap-3">
                                        <CheckIcon width="16px" fill="#C5A059" />
                                        <span className="text-primary font-medium">{item}</span>
                                    </li>
                                ))}
                            </ul>
                            {step.footnote && <p className="text-mono leading-relaxed">{step.footnote}</p>}
                        </div>

                        <div className={`hidden bg-moninho aspect-square rounded-[3rem] p-12 md:flex items-center justify-center shadow-xl shadow-primary/5 ${step.reverse ? "order-2 md:order-1" : ""}`}>
                            {step.icon}
                        </div>
                    </div>
                ))}

                <section className="bg-primary rounded-[3rem] p-12 md:p-20 text-white relative overflow-hidden shadow-2xl text-center">
                    <div className="relative z-10 max-w-2xl mx-auto space-y-8">
                        <h3 className="text-secondary font-bold tracking-widest text-sm uppercase">Nosso Compromisso</h3>
                        <p className="text-2xl md:text-3xl font-black leading-tight">
                            Nosso papel é conectar você a <span className="text-secondary">vendedores confiáveis</span>. Aproveite a experiência com tranquilidade e negocie com segurança.
                        </p>
                        <Link
                            to="/watches"
                            className="inline-block py-5 px-12 bg-secondary text-white font-black tracking-[0.2em] text-xs rounded-2xl hover:bg-secondary/90 transition-all shadow-xl shadow-black/20 hover:scale-105 active:scale-95"
                        >
                            VER RELÓGIOS DISPONÍVEIS
                        </Link>
                    </div>

                    <div className="absolute top-0 right-0 w-64 h-64 bg-secondary/10 rounded-full blur-[100px] -translate-y-1/2 translate-x-1/2" />
                </section>
            </div>

            <div className="fixed top-0 right-0 w-[500px] h-[500px] bg-secondary/[0.02] rounded-full blur-[120px] -z-10 pointer-events-none" />
            <div className="fixed bottom-0 left-0 w-[300px] h-[300px] bg-primary/[0.02] rounded-full blur-[100px] -z-10 pointer-events-none" />
        </main>
    )
}
